import { useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import useGetAccountStatementDetail from "../../../../hooks/queries/employee/useGetAccountStatementDetail";
import useGetAccount from "../../../../hooks/queries/employee/useGetAccount";
import Loader from "../../../../components/Loader";
import ErrorPage from "../../../../components/ErrorPage";

const StatementDetail = () => {
  const { yearMonth } = useParams();
  const { data: accountData } = useGetAccount();
  const { data, status } = useGetAccountStatementDetail(
    accountData?.challenger_saving.account_number,
    yearMonth
  );

  if (status === "loading") return <Loader />;
  if (status === "error") return <ErrorPage />;

  // DOMPurify to sanitize the html
  // we need to keep the styles since the html is coming from the backend
  const sanitizedHtml = DOMPurify.sanitize(data, {
    USE_PROFILES: { html: true },
    FORCE_BODY: true,
  });

  return (
    <div className="w-100" style={{ position: "relative" }}>
      <div
        style={{ width: "100%" }}
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
    </div>
  );
};

export default StatementDetail;
